export default "__VITE_ASSET__204719bc__"